<div class="p-5">
    <h2 class="primary text-center fw-bold">Prolunga le licenze</h2>
    <p class="text-center">
        Le licenze selezionate verranno prolungate.
    </p>
    <!-- Form -->
    <form [formGroup]="formExtendLicense" class="row g-3 mt-2">
        <app-form-input [inputItem]="extendLicenseFormFields().expirationDate"></app-form-input>
        <mat-dialog-actions class="d-flex gap-3">
            <button #initialFocus mat-dialog-close class="btn btn-primary-ks-white"
            (click)="onCancel()">Annulla</button> 
            <button class="btn btn-primary-ks"
            [disabled]="formExtendLicense.invalid" (click)="onSubmit()">Prolunga</button>
        </mat-dialog-actions>
    </form>
</div>